import {
  GeckoAssemblyJSON,
  GeckoEquipmentJSON,
  GeckoJobDataJSON,
  GeckoSubAssemblyJSON,
  RolodexEntryPutJson,
  RolodexEntryType,
} from 'types'

export function createEquipmentPutEntry(
  equipmentID: string,
  equipmentData: GeckoEquipmentJSON
): RolodexEntryPutJson {
  const equipmentPutEntry = {
    id: equipmentID,
    type: RolodexEntryType.EQUIPMENT,
    data: equipmentData,
    tags: {},
  }
  return equipmentPutEntry
}

export function createAssemblyPutEntry(
  assemblyID: string,
  assemblyData: GeckoAssemblyJSON
): RolodexEntryPutJson {
  const assemblyPutEntry = {
    id: assemblyID,
    type: RolodexEntryType.ASSEMBLY,
    data: assemblyData,
    tags: {},
  }
  return assemblyPutEntry
}

export function createSubAssemblyPutEntry(
  subAssemblyID: string,
  subAssemblyData: GeckoSubAssemblyJSON
): RolodexEntryPutJson {
  const subAssemblyPutEntry = {
    id: subAssemblyID,
    type: RolodexEntryType.SUB_ASSEMBLY,
    data: subAssemblyData,
    tags: {},
  }
  return subAssemblyPutEntry
}

export function createJobPutEntry(
  jobID: string,
  jobData: GeckoJobDataJSON,
  tags: { [key: string]: string | null }
): RolodexEntryPutJson {
  const jobPutEntry = {
    id: jobID,
    type: RolodexEntryType.JOB,
    data: jobData,
    tags: tags,
  }
  return jobPutEntry
}
